import React from 'react'
import { PlayerSafetyScreen } from '../../../components/settings/PlayerSafetyScreen'

export default function ReportUserScreen() {
  return <PlayerSafetyScreen reportOnly />
}
